export interface IUploadOrganizationReportingTemplateDto {
    id: string;
    reportingTemplateFile: FormData | null;
}
